module.exports = __webpack_public_path__ + "img/user-menu-user.36b4c22c.svg";